import AutoUpdateApp from "@/assets/js/newauto";
import { getVersionapi } from "../../network/api/login";
//设置方法名常量
const type = {
};
//变量
const state = {
}

const mutations = {
}
const actions = {
  autoupdateapp: function (context) {
    getVersionapi()
      .then(res => {
        let newVer = res.data.versionCode; //最新
        let wgturl = res.data.url;
        // console.log(AutoUpdateApp.AutoUpdateApp.getVersion)
        AutoUpdateApp.AutoUpdateApp.getVersion(newVer, wgturl); //当前版本
      })
      .catch(err => {
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/autoupdateapp.js